import React, { useContext } from "react";
import { LocalizationContext } from "../lib/context";

export default function InputCover({
  label,
  value,
  onClick,
  multiValues,
  buttonText,
}: {
  label: string;
  value: any;
  onClick: () => void;
  multiValues?: boolean;
  buttonText?: string;
}) {
  const { uiGeneral } = useContext(LocalizationContext).localeStrings;
  return (
    <div className="settings__inputCover">
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <h2 className="settings__secondaryText">{label}</h2>
        {multiValues && value?.length > 0 ? (
          value.map((item: string, index: number) => (
            <h3 key={index} className="settings__tertiaryText">
              {item}
            </h3>
          ))
        ) : (
          <h3 className="settings__tertiaryText">{value}</h3>
        )}
      </div>
      <h4 className="settings__underLineText" onClick={onClick}>
        {buttonText ? buttonText : uiGeneral.editButton}
      </h4>
    </div>
  );
}
